(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8286],{

/***/ 10:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);


var Back = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 12 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M5.99932 11.3327L2.66602 7.99931L5.99935 4.66602",
                stroke: "black",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M2.66602 8H13.3327",
                stroke: "black",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Back);


/***/ }),

/***/ 76030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);


var Close = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M9.31333 1.39325C9.50847 1.19811 9.50847 0.881726 9.31333 0.686585C9.11819 0.491445 8.8018 0.491445 8.60666 0.686585L5 4.29325L1.39333 0.686586C1.19819 0.491445 0.881802 0.491445 0.686662 0.686585C0.491521 0.881726 0.491521 1.19811 0.686662 1.39325L4.29333 4.99992L0.686662 8.60658C0.491521 8.80173 0.491521 9.11811 0.686662 9.31325C0.881802 9.50839 1.19819 9.50839 1.39333 9.31325L5 5.70659L8.60666 9.31325C8.8018 9.50839 9.11819 9.50839 9.31333 9.31325C9.50847 9.11811 9.50847 8.80173 9.31333 8.60659L5.70666 4.99992L9.31333 1.39325Z",
            fill: "#36354C"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Close);


/***/ }),

/***/ 7413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var _mobile_search_box_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18346);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11720);



var SearchIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mobile_search_box_styles__WEBPACK_IMPORTED_MODULE_1__/* .SearchIconContainer */ .qY, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
            width: "17",
            height: "17",
            viewBox: "0 0 17 17",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                    d: "M7.46785 14.9357C3.34088 14.9357 0 11.5948 0 7.46785C0 3.34088 3.34088 0 7.46785 0C11.5948 0 14.9357 3.34088 14.9357 7.46785C14.9357 11.5948 11.5948 14.9357 7.46785 14.9357ZM7.46785 1.47392C4.12697 1.47392 1.47392 4.12697 1.47392 7.46785C1.47392 10.8087 4.12697 13.4618 7.46785 13.4618C10.8087 13.4618 13.4618 10.8087 13.4618 7.46785C13.4618 4.12697 10.7105 1.47392 7.46785 1.47392Z",
                    fill: "#36354C"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                    d: "M16.0181 16.9997C15.7233 16.9997 15.5268 16.9014 15.3302 16.7049L11.7928 13.1675C11.3998 12.7745 11.3998 12.1849 11.7928 11.7919C12.1859 11.3988 12.7754 11.3988 13.1685 11.7919L16.7059 15.3293C17.0989 15.7223 17.0989 16.3119 16.7059 16.7049C16.5094 16.9014 16.3128 16.9997 16.0181 16.9997Z",
                    fill: "#36354C"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchIcon);


/***/ }),

/***/ 32724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92536);



var ItemElement = function(param) {
    var item = param.item;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ItemIcon */ .S5, {
        hide: !(item === null || item === void 0 ? void 0 : item.flag),
        children: (item === null || item === void 0 ? void 0 : item.flag) || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .DefaultName */ .dO, {
            children: item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref.slice(0, 2)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ItemElement);


/***/ }),

/***/ 93740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ multi_select_content; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./src/common/components/multi-select-input/styles.ts
var styles = __webpack_require__(92536);
// EXTERNAL MODULE: ./src/international-insurance/components/landing-page/common/Note.tsx
var Note = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.input/dist/index.js
var dist = __webpack_require__(23282);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.button/dist/index.js
var building_blocks_ui_button_dist = __webpack_require__(2518);
// EXTERNAL MODULE: ./src/common/components/multi-select-input/mobile/icon/index.tsx
var icon = __webpack_require__(32724);
;// CONCATENATED MODULE: ./src/common/components/multi-select-input/mobile/search-page/index.tsx







var Index = function(props) {
    var _totalValues = props.totalValues, totalValues = _totalValues === void 0 ? [] : _totalValues, _selectedValues = props.selectedValues, selectedValues = _selectedValues === void 0 ? [] : _selectedValues, handleAdd = props.handleAdd, _searchInput = props.searchInput, searchInput = _searchInput === void 0 ? "" : _searchInput, _isDesktop = props.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop;
    var ref = (0,compat_module.useState)(selectedValues || []), updatedSelection = ref[0], setUpdatedSelection = ref[1];
    var ref1 = (0,compat_module.useState)(totalValues), updatedItems = ref1[0], setUpdatedItems = ref1[1];
    (0,compat_module.useEffect)(function() {
        if (!!totalValues) {
            var searchTerm = searchInput === null || searchInput === void 0 ? void 0 : searchInput.trim();
            if (!!searchTerm) {
                var lowerCaseSearchTerm = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase();
                var updatedList = totalValues === null || totalValues === void 0 ? void 0 : totalValues.filter(function(param) {
                    var name = param.name, code = param.code, _abbr = param.abbr, abbr = _abbr === void 0 ? "" : _abbr, _cities = param.cities, cities = _cities === void 0 ? [] : _cities;
                    var ref;
                    var lowerCaseName = name === null || name === void 0 ? void 0 : name.toLowerCase();
                    var lowerCaseCode = code === null || code === void 0 ? void 0 : code.toLowerCase();
                    var lowerCaseAbbr = abbr === null || abbr === void 0 ? void 0 : abbr.toLowerCase();
                    var isCityMatching = (ref = cities === null || cities === void 0 ? void 0 : cities.map(function(city) {
                        var ref;
                        return city === null || city === void 0 ? void 0 : (ref = city.name) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                    })) === null || ref === void 0 ? void 0 : ref.some(function(city) {
                        return city === null || city === void 0 ? void 0 : city.startsWith(lowerCaseSearchTerm);
                    });
                    return (lowerCaseName === null || lowerCaseName === void 0 ? void 0 : lowerCaseName.startsWith(lowerCaseSearchTerm)) || (lowerCaseCode === null || lowerCaseCode === void 0 ? void 0 : lowerCaseCode.startsWith(lowerCaseSearchTerm)) || (lowerCaseAbbr === null || lowerCaseAbbr === void 0 ? void 0 : lowerCaseAbbr.startsWith(lowerCaseSearchTerm)) || isCityMatching;
                });
                setUpdatedItems(updatedList);
            } else setUpdatedItems(totalValues);
        }
    }, [
        searchInput
    ]);
    var handleUpdate = function(data) {
        var ref;
        if ((ref = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.map(function(param) {
            var code = param.code;
            return code;
        })) === null || ref === void 0 ? void 0 : ref.includes(data === null || data === void 0 ? void 0 : data.code)) {
            var newSelection = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.filter(function(param) {
                var code = param.code;
                return code !== (data === null || data === void 0 ? void 0 : data.code);
            });
            setUpdatedSelection(newSelection);
        } else setUpdatedSelection((0,_to_consumable_array/* default */.Z)(updatedSelection).concat([
            data
        ]));
        if (isDesktop) {
            var ref1;
            if ((ref1 = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.map(function(param) {
                var code = param.code;
                return code;
            })) === null || ref1 === void 0 ? void 0 : ref1.includes(data === null || data === void 0 ? void 0 : data.code)) {
                var newSelection1 = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.filter(function(param) {
                    var code = param.code;
                    return code !== (data === null || data === void 0 ? void 0 : data.code);
                });
                handleAdd(newSelection1);
            } else handleAdd((0,_to_consumable_array/* default */.Z)(updatedSelection).concat([
                data
            ]));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* SearchPage */.Z9, {
        isDesktop: isDesktop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PopularItemsContainer */.LR, {
                isDesktop: isDesktop,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* PopularItems */.Jj, {
                    children: [
                        updatedItems === null || updatedItems === void 0 ? void 0 : updatedItems.map(function(item) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)(styles/* ItemCheckbox */.Bl, {
                                onClick: function() {
                                    handleUpdate(item);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* Item */.ck, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(icon/* default */.Z, {
                                                item: item
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                style: {
                                                    order: isDesktop ? "2" : "unset"
                                                },
                                                children: item === null || item === void 0 ? void 0 : item.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.Checkbox, {
                                        className: "item-checkbox",
                                        onChange: function() {},
                                        checked: (ref = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.map(function(param) {
                                            var code = param.code;
                                            return code;
                                        })) === null || ref === void 0 ? void 0 : ref.includes(item === null || item === void 0 ? void 0 : item.code)
                                    })
                                ]
                            }, item === null || item === void 0 ? void 0 : item.code);
                        }),
                        (updatedItems === null || updatedItems === void 0 ? void 0 : updatedItems.length) === 0 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* ErrorMessage */.Bc, {
                            children: [
                                "No results found for ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("b", {
                                    children: '"'.concat(searchInput, '"')
                                })
                            ]
                        })
                    ]
                })
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* BottomCTA */.jp, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* ButtonContainer */.qO, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                        isFullWidth: true,
                        onClick: function() {
                            return handleAdd(updatedSelection);
                        },
                        disabled: (updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.length) < 1,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* ButtonText */.oD, {
                            children: "Add"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var search_page = (Index);

// EXTERNAL MODULE: ./src/common/components/multi-select-input/mobile/search-box/styles.ts
var search_box_styles = __webpack_require__(18346);
// EXTERNAL MODULE: ./src/common/components/multi-select-input/assets/icons/Search.tsx
var Search = __webpack_require__(7413);
// EXTERNAL MODULE: ./src/common/components/multi-select-input/assets/icons/Close.tsx
var Close = __webpack_require__(76030);
// EXTERNAL MODULE: ./src/common/components/multi-select-input/assets/icons/Back.tsx
var Back = __webpack_require__(10);
;// CONCATENATED MODULE: ./src/common/components/multi-select-input/mobile/search-box/index.tsx






var search_box_Index = function(props) {
    var _placeholder = props.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _value = props.value, value = _value === void 0 ? "" : _value, onChange = props.onChange, onFocus = props.onFocus, onBack = props.onBack, _inFocus = props.inFocus, inFocus = _inFocus === void 0 ? false : _inFocus;
    var ref = (0,compat_module.useState)(value), val = ref[0], setVal = ref[1];
    (0,compat_module.useEffect)(function() {
        if (!inFocus) {
            setVal("");
        }
    }, [
        inFocus
    ]);
    var handleChange = function(e) {
        var ref, ref1;
        setVal(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
        onChange(e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value);
    };
    var handleFocus = function() {
        onFocus && onFocus();
    };
    var handleBack = function() {
        setVal("");
        onBack && onBack();
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(search_box_styles/* SearchContainer */.Gh, {
        focus: inFocus,
        children: [
            !inFocus && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Search/* default */.Z, {}),
            inFocus && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(search_box_styles/* BackIconContainer */.r, {
                onClick: handleBack,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Back/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(search_box_styles/* Input */.II, {
                focus: inFocus,
                placeholder: placeholder,
                type: "text",
                value: val,
                onChange: handleChange,
                onFocus: handleFocus
            }),
            val && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(search_box_styles/* ClearIcon */.Rk, {
                onClick: function() {
                    setVal("");
                    onChange("");
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Close/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var search_box = (search_box_Index);

;// CONCATENATED MODULE: ./src/common/components/multi-select-input/assets/icons/Diamond.tsx


var DiamondIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                d: "M2.83293 1.1499L0.37793 4.2399L5.99793 11.4999L11.6179 4.2399L9.16293 1.1499H2.83293Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                d: "M5.99813 11.8899C5.94118 11.8897 5.88501 11.8766 5.8339 11.8514C5.78278 11.8263 5.73806 11.7899 5.70313 11.7449L0.0781307 4.4699C0.0274365 4.40299 0 4.32135 0 4.2374C0 4.15346 0.0274365 4.07181 0.0781307 4.0049L2.53813 0.914902C2.57381 0.871108 2.6188 0.835818 2.66983 0.8116C2.72086 0.787382 2.77664 0.774846 2.83313 0.774903H9.16313C9.21962 0.774846 9.2754 0.787382 9.32644 0.8116C9.37747 0.835818 9.42246 0.871108 9.45813 0.914902L11.9131 3.9999C11.9654 4.06611 11.9939 4.14802 11.9939 4.2324C11.9939 4.31678 11.9654 4.3987 11.9131 4.4649L6.29813 11.7449C6.26171 11.7895 6.21599 11.8255 6.16417 11.8506C6.11235 11.8756 6.05568 11.8891 5.99813 11.8899ZM0.853131 4.2449L5.99813 10.8999L11.1431 4.2449L8.96313 1.5249H3.01313L0.853131 4.2449Z",
                fill: "#36354C"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                d: "M3.05814 1.49463L1.72314 4.23963H4.84814L3.05814 1.49463Z",
                fill: "#FCC2D7"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                d: "M5.99805 10.9047L10.283 4.23975H7.13305L5.99805 10.9047Z",
                fill: "#FCC2D7"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                d: "M8.46293 4.61475H0.37793C0.278473 4.61475 0.183091 4.57524 0.112765 4.50491C0.0424385 4.43459 0.00292969 4.3392 0.00292969 4.23975C0.00292969 4.14029 0.0424385 4.04491 0.112765 3.97458C0.183091 3.90426 0.278473 3.86475 0.37793 3.86475H8.46293C8.56239 3.86475 8.65777 3.90426 8.7281 3.97458C8.79842 4.04491 8.83793 4.14029 8.83793 4.23975C8.83793 4.3392 8.79842 4.43459 8.7281 4.50491C8.65777 4.57524 8.56239 4.61475 8.46293 4.61475Z",
                fill: "#36354C"
            })
        ]
    });
};
/* harmony default export */ var Diamond = (DiamondIcon);

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.theme/dist/index.js
var building_blocks_ui_theme_dist = __webpack_require__(549);
// EXTERNAL MODULE: ./src/common/utils/responsive/index.tsx
var responsive = __webpack_require__(7010);
// EXTERNAL MODULE: ./src/common/components/multi-select-input/mobile/multi-select-content/list-item/index.tsx
var list_item = __webpack_require__(38055);
// EXTERNAL MODULE: ./src/common/components/multi-select-input/mobile/multi-select-content/item-pill/index.tsx
var item_pill = __webpack_require__(59138);
;// CONCATENATED MODULE: ./src/common/components/multi-select-input/mobile/multi-select-content/index.tsx













var multi_select_content_Index = function(param) {
    var searchPlaceholder = param.searchPlaceholder, popularValues = param.popularValues, title = param.title, subTitle = param.subTitle, totalValues = param.totalValues, note = param.note, _isInfoNote = param.isInfoNote, isInfoNote = _isInfoNote === void 0 ? false : _isInfoNote, continueCTA = param.continueCTA, updatedSelection = param.updatedSelection, setUpdatedSelection = param.setUpdatedSelection, handleSubmit = param.handleSubmit, _hideContinueCta = param.hideContinueCta, hideContinueCta = _hideContinueCta === void 0 ? false : _hideContinueCta;
    var theme = (0,building_blocks_ui_theme_dist.useTheme)().theme;
    var colors = (0,building_blocks_ui_theme_dist.useColor)();
    var ref = (0,compat_module.useState)(""), searchInput = ref[0], setSearchInput = ref[1];
    var ref1 = (0,compat_module.useState)(false), showSearch = ref1[0], setShowSearch = ref1[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var handleUpdate = function(data) {
        var ref;
        if ((ref = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.map(function(param) {
            var code = param.code;
            return code;
        })) === null || ref === void 0 ? void 0 : ref.includes(data === null || data === void 0 ? void 0 : data.code)) {
            var newSelection = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.filter(function(param) {
                var code = param.code;
                return code !== (data === null || data === void 0 ? void 0 : data.code);
            });
            setUpdatedSelection(newSelection);
        } else setUpdatedSelection((0,_to_consumable_array/* default */.Z)(updatedSelection).concat([
            data
        ]));
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* MobileContainer */.OJ, {
        theme: theme,
        colors: colors,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* SearchContainer */.Gh, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(search_box, {
                        placeholder: searchPlaceholder,
                        onChange: function(val) {
                            return setSearchInput(val);
                        },
                        onFocus: function() {
                            return setShowSearch(true);
                        },
                        onBack: function() {
                            setShowSearch(false);
                            setSearchInput("");
                        },
                        inFocus: showSearch
                    }),
                    !!note && (isInfoNote ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Note/* default */.Z, {
                        text: note
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* Note */.jC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Diamond, {}),
                            note
                        ]
                    }))
                ]
            }),
            !showSearch && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* MobileContent */.z9, {
                isMobile: isMobile,
                children: [
                    (updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* SelectedContainer */.U6, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* SelectedItems */.Ad, {
                            children: updatedSelection.map(function(item) {
                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(item_pill/* default */.Z, {
                                    item: item,
                                    handleUpdate: function() {
                                        return handleUpdate(item);
                                    }
                                }, item === null || item === void 0 ? void 0 : item.code);
                            })
                        })
                    }),
                    !!popularValues && (popularValues === null || popularValues === void 0 ? void 0 : popularValues.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* PopularItemsContainer */.LR, {
                        isDesktop: false,
                        removeExtraMargin: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* TitleWrapper */.$t, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* ModalTitle */.r6, {
                                        marginBottom: isMobile ? "4px" : "20px",
                                        children: [
                                            title,
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* TitleIcon */.zg, {
                                                src: "https://acko-cms.ackoassets.com/trending_icon_676ca6fa84.png"
                                            })
                                        ]
                                    }),
                                    subTitle && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* SubTitle */.DK, {
                                        children: subTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PopularItems */.Jj, {
                                children: popularValues === null || popularValues === void 0 ? void 0 : popularValues.map(function(item) {
                                    var ref;
                                    var checked = (ref = updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.map(function(param) {
                                        var code = param.code;
                                        return code;
                                    })) === null || ref === void 0 ? void 0 : ref.includes(item === null || item === void 0 ? void 0 : item.code);
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(list_item/* default */.Z, {
                                        item: item,
                                        checked: checked,
                                        handleUpdate: function() {
                                            return handleUpdate(item);
                                        }
                                    }, item === null || item === void 0 ? void 0 : item.code);
                                })
                            })
                        ]
                    }),
                    hideContinueCta ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* BottomCTA */.jp, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* ButtonContainer */.qO, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                isFullWidth: true,
                                onClick: function() {
                                    handleSubmit();
                                    setSearchInput("");
                                    setShowSearch(false);
                                },
                                disabled: (updatedSelection === null || updatedSelection === void 0 ? void 0 : updatedSelection.length) < 1,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* ButtonText */.oD, {
                                    children: continueCTA
                                })
                            })
                        })
                    })
                ]
            }),
            showSearch && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(search_page, {
                totalValues: totalValues,
                selectedValues: updatedSelection,
                handleAdd: function(updatedList) {
                    setUpdatedSelection(updatedList);
                    setShowSearch(false);
                    setSearchInput("");
                },
                searchInput: searchInput,
                isDesktop: !isMobile
            })
        ]
    });
};
/* harmony default export */ var multi_select_content = (multi_select_content_Index);


/***/ }),

/***/ 59138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92536);
/* harmony import */ var _assets_icons_Close__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76030);




var Index = function(param) {
    var item = param.item, handleUpdate = param.handleUpdate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ItemPill */ .U3, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                children: item === null || item === void 0 ? void 0 : item.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RemoveItem */ .Qk, {
                onClick: function() {
                    return handleUpdate(item);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_assets_icons_Close__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
            })
        ]
    }, item === null || item === void 0 ? void 0 : item.code);
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 38055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92536);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32724);
/* harmony import */ var _acko_tech_building_blocks_ui_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23282);
/* harmony import */ var _acko_tech_building_blocks_ui_input__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_input__WEBPACK_IMPORTED_MODULE_4__);





var Index = function(param) {
    var item = param.item, checked = param.checked, handleUpdate = param.handleUpdate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ItemCheckbox */ .Bl, {
        onClick: function() {
            return handleUpdate(item);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Item */ .ck, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        item: item
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        children: item === null || item === void 0 ? void 0 : item.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_acko_tech_building_blocks_ui_input__WEBPACK_IMPORTED_MODULE_4__.Checkbox, {
                className: "item-checkbox",
                onChange: function() {},
                checked: checked
            })
        ]
    }, item === null || item === void 0 ? void 0 : item.code);
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 18346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gh": function() { return /* binding */ SearchContainer; },
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "Rk": function() { return /* binding */ ClearIcon; },
/* harmony export */   "qY": function() { return /* binding */ SearchIconContainer; },
/* harmony export */   "r": function() { return /* binding */ BackIconContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79749);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(549);
/* harmony import */ var _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #040222;\n  height: 46px;\n  border: 1px solid;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  background: white;\n  border-radius: 8px;\n  outline-style: none;\n  border: none;\n  font-weight: ",
        ";\n  font-size: 0.9rem;\n\n  @media screen and (max-width: 768px) {\n    caret-color: transparent;\n  }\n\n  ::placeholder,\n  ::-webkit-input-placeholder {\n    color: rgb(91, 86, 117);\n    font-style: normal;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.5rem;\n    opacity: 0.8;\n  }\n  :-ms-input-placeholder {\n    font-style: normal;\n    color: rgb(91, 86, 117);\n    font-style: normal;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.5rem;\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  padding: 0 10px 0 20px;\n  height: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  padding: 4px 2px 0 15px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  padding: 4px 15px 0 15px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SearchContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
});
var Input = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.input(_templateObject1(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.C1;
});
var SearchIconContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject2());
var BackIconContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject3());
var ClearIcon = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject4());


/***/ }),

/***/ 92536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ TitleWrapper; },
/* harmony export */   "Ad": function() { return /* binding */ SelectedItems; },
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "Bl": function() { return /* binding */ ItemCheckbox; },
/* harmony export */   "C5": function() { return /* binding */ DesktopContainer; },
/* harmony export */   "DJ": function() { return /* binding */ MobileHeader; },
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "DZ": function() { return /* binding */ DropdownContainer; },
/* harmony export */   "Gh": function() { return /* binding */ SearchContainer; },
/* harmony export */   "I": function() { return /* binding */ Blocker; },
/* harmony export */   "Jj": function() { return /* binding */ PopularItems; },
/* harmony export */   "LR": function() { return /* binding */ PopularItemsContainer; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; },
/* harmony export */   "OJ": function() { return /* binding */ MobileContainer; },
/* harmony export */   "Qk": function() { return /* binding */ RemoveItem; },
/* harmony export */   "S5": function() { return /* binding */ ItemIcon; },
/* harmony export */   "U3": function() { return /* binding */ ItemPill; },
/* harmony export */   "U6": function() { return /* binding */ SelectedContainer; },
/* harmony export */   "VG": function() { return /* binding */ Name; },
/* harmony export */   "Wx": function() { return /* binding */ DesktopDropdownItems; },
/* harmony export */   "XF": function() { return /* binding */ Count; },
/* harmony export */   "YS": function() { return /* binding */ DesktopNote; },
/* harmony export */   "Z9": function() { return /* binding */ SearchPage; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "ck": function() { return /* binding */ Item; },
/* harmony export */   "dO": function() { return /* binding */ DefaultName; },
/* harmony export */   "eI": function() { return /* binding */ SelectContainer; },
/* harmony export */   "iJ": function() { return /* binding */ InFocusInput; },
/* harmony export */   "jC": function() { return /* binding */ Note; },
/* harmony export */   "jp": function() { return /* binding */ BottomCTA; },
/* harmony export */   "oD": function() { return /* binding */ ButtonText; },
/* harmony export */   "or": function() { return /* binding */ Main; },
/* harmony export */   "qD": function() { return /* binding */ DesktopButton; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; },
/* harmony export */   "r6": function() { return /* binding */ ModalTitle; },
/* harmony export */   "rJ": function() { return /* binding */ InputLabelContainer; },
/* harmony export */   "xR": function() { return /* binding */ DesktopContent; },
/* harmony export */   "z9": function() { return /* binding */ MobileContent; },
/* harmony export */   "zg": function() { return /* binding */ TitleIcon; }
/* harmony export */ });
/* unused harmony exports ButtonLoaderImage, BoldText, SearchItem */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79749);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(549);
/* harmony import */ var _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  background-color: #ffffff;\n  font-size: ",
        ";\n  left: 12px;\n  top: -8px;\n  padding: 0 4px;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n  background: #ffffff;\n  border: 1px solid #e7e7f0;\n  border-radius: 8px;\n\n  color: ",
        ";\n  font-style: normal;\n  padding: 14px 12px;\n  max-height: 110px;\n  overflow: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  width: 100%;\n  height: ",
        ";\n  overflow: scroll;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-weight: 400;\n  font-style: normal;\n  color: rgb(91, 86, 117);\n  padding: 8px;\n  border-radius: 8px;\n  margin-top: 16px;\n  background: linear-gradient(\n    to right,\n    rgba(251, 233, 246, 0.68),\n    rgba(255, 207, 242, 0.56)\n  );\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-weight: 400;\n  font-style: normal;\n  color: rgb(91, 86, 117);\n  padding: 8px;\n  border-radius: 8px;\n  margin-top: 8px;\n  background: #e2f5ff;\n  margin: 0 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  display: inline-block;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  width: 100%;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  margin-top: ",
        ";\n  position: relative;\n  cursor: pointer;\n  margin: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  width: 65px;\n  position: absolute;\n  left: 50%;\n  margin-top: ",
        ";\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  visibility: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  position: relative;\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  background: transparent;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px 0 20px;\n  width: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  row-gap: 8px;\n  flex-wrap: wrap;\n  // max-height: 110px;\n  overflow: auto;\n  padding-right: 10px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 12px;\n  gap: 8px;\n  text-transform: capitalize;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  background: #efe9fb;\n  border: 1px solid #d0bdf4;\n  border-radius: 20px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  margin-bottom: ",
        ";\n  position: relative;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: auto;\n  margin: 20px;\n  padding-right: 10px;\n  max-height: 320px;\n  overflow: auto;\n\n  @media screen and (min-width: 768px) {\n    max-height: 264px;\n    ::-webkit-scrollbar {\n      width: 4px;\n      background: rgb(217, 217, 217);\n      display: block;\n      border-radius: 32px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n      border-radius: 32px;\n      background: rgb(111, 109, 109);\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: auto;\n  margin: 0 20px;\n  overflow: auto;\n\n  @media screen and (min-width: 768px) {\n    max-height: 264px;\n    padding-right: 10px;\n    ::-webkit-scrollbar {\n      width: 4px;\n      background: rgba(217, 217, 217, 0.5);\n      display: block;\n      border-radius: 32px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n      border-radius: 32px;\n      background: rgba(111, 109, 109, 0.7);\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: ",
        ";\n  gap: 10px;\n  font-weight: ",
        ";\n  font-size: 1rem;\n  line-height: ",
        ";\n  border-bottom: 1px solid #e7e7f0;\n  padding: 16px 0px;\n  cursor: pointer;\n\n  @media screen and (min-width: 768px) {\n    &:first-child {\n      padding-top: unset;\n    }\n  }\n\n  &:last-child {\n    border-bottom: unset;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 20px;\n  font-style: normal;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  margin: 20px;\n  margin-top: 5px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 16px;\n  height: 16px;\n  margin-left: 5px;\n  margin-bottom: -2px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  margin-top: ",
        ";\n  padding-left: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  padding-left: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  border-bottom: 1px solid #e7e7f0;\n  padding: 16px 0;\n  padding-left: 10px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  background: #ffffff;\n  border: 1px solid #e7e7f0;\n  box-shadow: 0px 4px 6px -2px rgba(54, 53, 76, 0.08);\n  border-radius: 8px;\n  padding-top: 20px;\n  position: absolute;\n  top: ",
        ";\n  z-index: 2;\n  width: ",
        ";\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-shadow: 0px -4px 8px -2px rgba(54, 53, 76, 0.1);\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background: white;\n  border-radius: ",
        ";\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-shadow: 0px -4px 8px -2px rgba(54, 53, 76, 0.1);\n  width: calc(100% - 1px);\n  background: white;\n  border-radius: 0 0 8px 8px;\n  border-top: unset;\n  padding-top: 1px;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transform: ",
        ";\n  transition: transform 0.2s ease-in-out;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 0 0 2px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: ",
        ";\n  overflow: scroll;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 5px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.25rem;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  color: #5b5675;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  width: 32px;\n  height: 24px;\n  background: ",
        ";\n  border-radius: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}


var Label = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.P2;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.neutral.n400;
});
var InFocusInput = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject1(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.open) ? "flex" : "none";
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
});
var SearchPage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject2(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
}, function(props) {
    return props.isDesktop ? "250px" : "calc(100vh - 240px)";
});
var Note = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject3());
var DesktopNote = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject4());
var SearchInput = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.input(_templateObject5(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.P1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.P1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.P1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.neutral.n400;
});
var Main = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject6(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
});
var MobileContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject7(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
});
var ButtonContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject8(), function(props) {
    return props.marginTop || "10px";
});
var ButtonLoaderImage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject9(), function(props) {
    return props.visibility ? "block" : "none";
}, function(props) {
    return props.marginTop || "30px";
});
var ButtonText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject10(), function(props) {
    return props.hide ? "hidden" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.P1;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.weight) || _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.T1;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.lineHeight) || _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.P2;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.padding) || "4px 0";
});
var SelectContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject11(), function(props) {
    return props && props.styles;
});
var Blocker = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject12());
var BoldText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject13(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.T1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.H4;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.T2;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.padding) || "30px 0 10px 0";
});
var MobileHeader = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject14(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.H1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.H4;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.T2;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.padding) || "30px 0 10px 0";
});
var SelectedItems = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject15());
var ItemPill = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject16(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.P1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.P2;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.T4_M;
});
var PopularItemsContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject17(), function(props) {
    return props.isDesktop || props.removeExtraMargin ? "0" : "100px";
});
var DesktopDropdownItems = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject18());
var PopularItems = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject19());
var ItemCheckbox = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject20(), function(props) {
    return props.justify || "space-between";
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.P1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.T4_M;
});
var SearchContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject21());
var SelectedContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject22());
var TitleIcon = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject23());
var TitleWrapper = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject24(), function(props) {
    return props.marginBottom || "20px";
});
var ModalTitle = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject25(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.H1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.T3;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.T3;
}, function(props) {
    return props.marginTop || "0px";
}, function(props) {
    return props.left || "20px";
});
var SubTitle = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject26(), function(props) {
    return props.left || "20px";
});
var SearchItem = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject27(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.P1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.T4_M;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.T4_M;
});
var DesktopContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject28(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
}, function(props) {
    return "".concat(props === null || props === void 0 ? void 0 : props.height, "px") || 0;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.dropdownWidth) || "58px";
});
var ErrorMessage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject29(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.P1;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.T3;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.lineHeights.T2;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.primary.n600;
});
var BottomCTA = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject30(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.radius) || "0";
});
var DesktopButton = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject31());
var DropdownContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject32(), function(props) {
    return props.open ? "rotate(180deg)" : "";
});
var RemoveItem = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject33());
var MobileContent = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject34(), function(props) {
    return props.isMobile ? "calc(100vh - 240px)" : "240px";
});
var DesktopContent = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject35());
var InputLabelContainer = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject36());
var Name = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject37());
var Count = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject38());
var Item = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject39());
var ItemIcon = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject40(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.H1;
}, function(props) {
    return props.hide ? _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.neutral.n300 : "transparent";
}, function(props) {
    return props.hide ? "4px" : "0";
});
var DefaultName = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject41(), function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.weight.T2;
}, function() {
    return _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.typography.fonts.size.C1;
}, _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_2__.AckoMainTheme.colors.light.neutral.n400);


/***/ }),

/***/ 8251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ person_count; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(79749);
;// CONCATENATED MODULE: ./src/common/components/person-count/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid #e8e8e8;\n  background-color: white;\n  position: relative;\n  z-index: 2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: #121212;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: #4b4b4b;\n  margin-top: 4px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border: 1px solid #B0B0B0\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  user-select: none;\n  color: ",
        ";\n  font-size: 1.5rem;\n  padding-bottom: 2px;\n\n  @media only screen and (max-width: 768px) {\n    font-size: 1.25rem;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  user-select: none;\n  width: 32px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background: #e2f5ff;\n  border-radius: 8px;\n  padding: 6px 10px;\n  align-items: center;\n  margin-top: 8px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: #5b5675;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var PersonContainer = dist.styled.div(_templateObject());
var DescriptionContainer = dist.styled.div(_templateObject1());
var LeftDesc = dist.styled.div(_templateObject2());
var PrimaryText = dist.styled.div(_templateObject3());
var SecondaryText = dist.styled.div(_templateObject4());
var RightDesc = dist.styled.div(_templateObject5());
var CounterButton = dist.styled.div(_templateObject6(), function(props) {
    return props.disabled ? "#E0E0E8" : "#040222";
});
var Counter = dist.styled.div(_templateObject7());
var NudgeContainer = dist.styled.div(_templateObject8());
var NudgeDesc = dist.styled.div(_templateObject9());

// EXTERNAL MODULE: ./src/common/utils/config/index.ts
var config = __webpack_require__(79354);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/common/components/person-count/index.tsx
/* eslint-disable @next/next/no-img-element */ 




var Index = function(props) {
    var _title = props.title, title = _title === void 0 ? "" : _title, _sub_title = props.sub_title, sub_title = _sub_title === void 0 ? "" : _sub_title, _count = props.count, count = _count === void 0 ? 0 : _count, _minLimit = props.minLimit, minLimit = _minLimit === void 0 ? 0 : _minLimit, _maxLimit = props.maxLimit, maxLimit = _maxLimit === void 0 ? null : _maxLimit, _note = props.note, note = _note === void 0 ? null : _note, _category = props.category, category = _category === void 0 ? "" : _category, handleUpdate = props.handleUpdate;
    var ref = (0,compat_module.useState)(), max = ref[0], setMax = ref[1];
    var ref1 = (0,compat_module.useState)(), min = ref1[0], setMin = ref1[1];
    var ref2 = (0,compat_module.useState)(count), counter = ref2[0], setCounter = ref2[1];
    (0,compat_module.useEffect)(function() {
        var temp = minLimit;
        setMin(temp);
        if (maxLimit) setMax(maxLimit);
    }, []);
    (0,compat_module.useEffect)(function() {
        setCounter(count);
    }, [
        count
    ]);
    (0,compat_module.useEffect)(function() {
        var data = {
            counter: counter,
            category: category
        };
        handleUpdate(data);
    }, [
        counter
    ]);
    var incrementCounter = function() {
        var temp;
        if (max) temp = Math.min(max, counter + 1);
        else temp = counter + 1;
        if (counter === 0 && temp === counter + 1) {
            setTimeout(function() {
                setCounter(temp);
            }, 50);
        } else setCounter(temp);
    };
    var decrementCounter = function() {
        var temp;
        if (min) temp = Math.max(min, counter - 1);
        else temp = Math.max(0, counter - 1);
        setCounter(temp);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PersonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DescriptionContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LeftDesc, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PrimaryText, {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SecondaryText, {
                                    children: [
                                        "(",
                                        sub_title,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RightDesc, {
                            className: "disable-dbl-tap-zoom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CounterButton, {
                                    disabled: counter === min,
                                    onClick: function() {
                                        return decrementCounter();
                                    },
                                    children: "—"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Counter, {
                                    children: counter || 0
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CounterButton, {
                                    disabled: max && counter === max,
                                    onClick: function() {
                                        return incrementCounter();
                                    },
                                    children: "+"
                                })
                            ]
                        })
                    ]
                })
            }),
            note && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(NudgeContainer, {
                counter: counter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: config/* ASSETS.BLACK_INFO_ICON */.ou.BLACK_INFO_ICON,
                        height: "16px",
                        width: "16px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NudgeDesc, {
                        children: note === null || note === void 0 ? void 0 : note.text
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var person_count = (Index);


/***/ }),

/***/ 87528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getSortedTrendingCountries; }
/* harmony export */ });
var getSortedTrendingCountries = function(countries) {
    var ref, ref1;
    return countries.filter(function(c) {
        return c === null || c === void 0 ? void 0 : c.is_trending;
    }).sort(function(a, b) {
        return ((ref = b === null || b === void 0 ? void 0 : b.trending_score) !== null && ref !== void 0 ? ref : 0) - ((ref1 = a === null || a === void 0 ? void 0 : a.trending_score) !== null && ref1 !== void 0 ? ref1 : 0);
    });
};


/***/ }),

/***/ 73098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22934);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79354);





var Index = function(param) {
    var text = param.text, _iconUrl = param.iconUrl, iconUrl = _iconUrl === void 0 ? src_common_utils_config__WEBPACK_IMPORTED_MODULE_3__/* .ASSETS.BLACK_INFO_ICON */ .ou.BLACK_INFO_ICON : _iconUrl, _wrapperStyles = param.wrapperStyles, wrapperStyles = _wrapperStyles === void 0 ? {} : _wrapperStyles, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 14 : _iconSize, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "12px" : _fontSize, _lineHeight = param.lineHeight, lineHeight = _lineHeight === void 0 ? "16px" : _lineHeight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().noteContainer),
        style: wrapperStyles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().noteIcon),
                style: {
                    width: "".concat(iconSize, "px"),
                    minWidth: "".concat(iconSize, "px"),
                    height: "".concat(iconSize, "px")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: iconUrl,
                    alt: "note-icon",
                    height: iconSize,
                    width: iconSize
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().noteText),
                style: {
                    fontSize: fontSize,
                    lineHeight: lineHeight
                },
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 22934:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"landingPageHeaderSection":"styles_landingPageHeaderSection__OSygn","backButton":"styles_backButton__7c_3n","videoContainer":"styles_videoContainer__W1O1M","content":"styles_content__eLULH","placeholder":"styles_placeholder__viDNr","title":"styles_title__sUZIj","fixedSearchBar":"styles_fixedSearchBar__8US7y","AnimatedEntry":"styles_AnimatedEntry__XCW0C","searchBar":"styles_searchBar__atYX3","searchText":"styles_searchText__3sP4e","sectionTitle":"styles_sectionTitle__KZ8xy","highlightText":"styles_highlightText__r_Hel","uspSection":"styles_uspSection__KzUg8","uspCards":"styles_uspCards__EevIH","uspCard":"styles_uspCard__WLp77","cardTitle":"styles_cardTitle__0ZDwQ","cardSubtitle":"styles_cardSubtitle__oCuvL","seeMoreAction":"styles_seeMoreAction___amSD","comparisonSection":"styles_comparisonSection__ZjJWg","modalTitle":"styles_modalTitle__PQVJh","comparisonModal":"styles_comparisonModal__Vymzw","listItem":"styles_listItem__ZzkS_","statsContainer":"styles_statsContainer__pEkkR","ackoStats":"styles_ackoStats__vPgo7","ackoLogo":"styles_ackoLogo__QKawr","otherStats":"styles_otherStats__YOnRi","otherTag":"styles_otherTag__MsZ_h","modalButton":"styles_modalButton__2HAeW","claimInfoSection":"styles_claimInfoSection__Hl0P0","claimInfoCard":"styles_claimInfoCard__dPy_f","planeImageContainer":"styles_planeImageContainer__p0Ovc","claimInfoCardTitle":"styles_claimInfoCardTitle__UHBig","claimInfoCardSubtitle":"styles_claimInfoCardSubtitle__kB3t1","claimInfoCardStats":"styles_claimInfoCardStats__gOxKe","statTitle":"styles_statTitle__x3fUb","statValue":"styles_statValue__FBkAi","coverageInfoSection":"styles_coverageInfoSection__HhPmG","coverageInfoContent":"styles_coverageInfoContent__5Q_3o","coverageInfoCards":"styles_coverageInfoCards__04pq9","coverageInfoHead":"styles_coverageInfoHead__VG_Co","coverageInfoHighlight":"styles_coverageInfoHighlight__sotCu","coverageInfoSubtitle":"styles_coverageInfoSubtitle__KpdjO","coverageInfoCardContainer":"styles_coverageInfoCardContainer__CJgwh","coverageInfoCardImage":"styles_coverageInfoCardImage__k8_nw","coverageInfoCard":"styles_coverageInfoCard__iDyzM","coverageInfoCardTitle":"styles_coverageInfoCardTitle__HOEdW","coverages":"styles_coverages__Sx9ac","coveragePill":"styles_coveragePill__V7UfU","activeCoveragePill":"styles_activeCoveragePill__eFjAs","coverageInfoNote":"styles_coverageInfoNote___57cx","coverageInfoNoteText":"styles_coverageInfoNoteText__CKfJn","customerSupportSection":"styles_customerSupportSection__SI5cF","customerSupportHighlight":"styles_customerSupportHighlight__P2MTp","customerSupportSubtitle":"styles_customerSupportSubtitle__jJGyp","phoneImageContainer":"styles_phoneImageContainer__YaKuv","helpContainer":"styles_helpContainer__TzZhf","animatedFormEntryClass":"styles_animatedFormEntryClass__Og_f7","FadeInOutAnimation":"styles_FadeInOutAnimation__erHJs","animatedPageEntryClass":"styles_animatedPageEntryClass__lECam","tripDetailsCollection":"styles_tripDetailsCollection__RYMa5","tripDetailsCollectionCloseButton":"styles_tripDetailsCollectionCloseButton__NQn64","tripDetailsFormContent":"styles_tripDetailsFormContent__UjwPw","mainContainer":"styles_mainContainer__gLJ_Q","inputContainer":"styles_inputContainer__6jlnt","whereSearchInput":"styles_whereSearchInput__j3zHw","multiSelectContainer":"styles_multiSelectContainer__EAY0M","openSearchStyles":"styles_openSearchStyles__Pn9v_","inputTitle":"styles_inputTitle__WRAJ0","displayContainer":"styles_displayContainer__8vLNJ","displayHead":"styles_displayHead__Z76zK","displayHeadOpen":"styles_displayHeadOpen__PSwrY","displayTitle":"styles_displayTitle__IwzRg","displayIcon":"styles_displayIcon__gZWBp","displayValue":"styles_displayValue__zK4Fs","travellersContainer":"styles_travellersContainer__IbQWU","travellerCategory":"styles_travellerCategory__Xwbmp","travellerCategoryTitle":"styles_travellerCategoryTitle__ul7yp","travellerCategorySubtitle":"styles_travellerCategorySubtitle__GIvHp","counterContainer":"styles_counterContainer__tRjGp","travellerCounter":"styles_travellerCounter__Vnwkq","travellerCountValue":"styles_travellerCountValue___8Eyy","popularCountriesTitle":"styles_popularCountriesTitle__8frCd","subTitle":"styles_subTitle__KMsw0","trendingIcon":"styles_trendingIcon__FC_KZ","popularCountriesList":"styles_popularCountriesList__kwUj0","countriesList":"styles_countriesList__dYL8S","selectedCountriesContainer":"styles_selectedCountriesContainer__OfVZ3","floatingBottom":"styles_floatingBottom__OgfOK","blueClearAll":"styles_blueClearAll__BUK0f","clearAllAction":"styles_clearAllAction__UkJ9C","nextAction":"styles_nextAction__zTtvj","disableNextAction":"styles_disableNextAction__oh0FF","countrySelectorActions":"styles_countrySelectorActions__bidgs","errorMessage":"styles_errorMessage__NbVnr","packagesContainer":"styles_packagesContainer__0gcMA","mobilePackageCard":"styles_mobilePackageCard__WgnI3","mobileCardContent":"styles_mobileCardContent__bSp_3","mobileRecommendedCard":"styles_mobileRecommendedCard__Qcqqz","recommendedTag":"styles_recommendedTag__4JYem","recommendedTagText":"styles_recommendedTagText__cguUJ","mobileSelectedCard":"styles_mobileSelectedCard__XwzwA","noteContainer":"styles_noteContainer__NmXbv","noteIcon":"styles_noteIcon__VxQZ1","noteText":"styles_noteText__snzC1","couponInfoContainer":"styles_couponInfoContainer__hrNrN","staticCarousal":"styles_staticCarousal__xeY5u","carousalContainer":"styles_carousalContainer__PbRM_","carousalItem":"styles_carousalItem__oBOS7","tracker":"styles_tracker__x8kC6","trackerDot":"styles_trackerDot__ZsBHq","activeDot":"styles_activeDot__GKC4n","testimonialCard":"styles_testimonialCard__3bG2S","testimonialCardHead":"styles_testimonialCardHead__X8_Y4","avatar":"styles_avatar__NqsQy","customerName":"styles_customerName__ZFVVo","customerHandle":"styles_customerHandle__Bxxoy","customerFeedback":"styles_customerFeedback__rmx3M","searchContainer":"styles_searchContainer__g0B1a","searchInput":"styles_searchInput__pk8sp","searchIconContainer":"styles_searchIconContainer__AVl3E","backIconContainer":"styles_backIconContainer__h7g_k","clearIcon":"styles_clearIcon__Od_MY","searchErrorMessage":"styles_searchErrorMessage__a5e9_","show":"styles_show__VSdwz","hide":"styles_hide__N_70Z"};

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

}]);